import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface AdminUserState {
  filterData: Record<string, any>;
  reloadTableData: boolean;
}

const initialState: AdminUserState = {
  filterData: {},
  reloadTableData: false,
};

const adminUserSlice = createSlice({
  name: 'adminUser',
  initialState,
  reducers: {
    setFilterData(state, action: PayloadAction<Record<string, any>>) {
      state.filterData = { ...state.filterData, ...action.payload };
    },
    resetFilterData(state) {
      state.filterData = {};
    },
    setReloadTableData(state, action: PayloadAction<boolean>) {
      state.reloadTableData = action.payload;
    },
  },
});

export const { setFilterData, resetFilterData, setReloadTableData } = adminUserSlice.actions;

export default adminUserSlice.reducer;
